<template>
    <div>
        <div class="wrapper">
            <div class="body">
                <div class="box-horizontal" style="position:fixed; top: 0;right: 0;left: 0;bottom: 0;">
                    <div class="mb20 bg-round-white pt20 pb20 flex-1 mr10 ml10" v-show="!get.data.isSuccess">
                        <div class="dialog-inner ml10 mr10 text-left">
                            <span class="block mb10 hitam">Selamat Datang,</span>
                            <h3 class="mt10 mb20 f17 primary-color">WIFIKU.web.id</h3>

                            <span class="block mb10 gray">Masukkan Nomer Telepon</span>
                            <input type="number" v-model="get.data.telepon" class="hitam pt10 pb10 w100 mb20 f13" style="border:0; border-bottom:1px solid #333;" placeholder="Telepon...">
                            
                            <span class="block mb10 orange text-center" v-show="get.data.kosongText">Telepon dan Password tidak boleh kosong</span>

                            <button class="btn btn-info w100 mb10" v-show="get.data.afterKlik" @click="get.data.afterKlik = false;met.login()">Gas Cek!</button>
                            <button class="btn btn-info w100 mb10" v-show="!get.data.afterKlik">Loading...</button>
                            
                            <span class="block mb20 hitam f12 text-center gray">Telepon dan Password tanyakan pada Layanan Internet yg anda gunakan.</span>

                            <span class="block mb10 hitam f12 text-center gray">Support by</span>
                            <span class="block mb20 f12 text-center primary-color">Beatcom | Males Developer</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import myGlobal from '@/MyGlobal'
import { reactive } from '@vue/composition-api'
import store from '@/store/index'
import inter from '@/Interface'
import router from '@/router'
import Loading from '@/global/Loading' 

export default {
    setup() {
        const get = {
            data: reactive({
                this: '',
                telepon: '',
                isSuccess: false,
                kosongText: false,
                afterKlik: true
            }),
            list() {
                var datax = {
                    token: 'TangTung '+sessionStorage.getItem("tokenu")
                };
            
                var apiUrl = inter.Bantuan(); 

                myGlobal.call(datax,apiUrl).then(x => {
                    //console.log(JSON.stringify(x));

                    if (x.status == true) {
                        this.data.list = x.data;
                    } else {
                        
                    }
                    
                })
            }
        }

        const met = {
            back() {
                window.history.back();
            },
            login() {
                if (get.data.telepon == "") {
                    get.data.afterKlik = true;
                    get.data.kosongText = true;
                    return false;
                }
                
                location.href="#/nl-detail/"+get.data.telepon;
            }
        }

        return {
            get,
            met
        }

    },
    mounted () {        

        this.get.list();
    }
}
</script>


// WEBPACK FOOTER //
// src/components/User/Login/main-no.vue